import routerOptions0 from "C:/Users/zreat/Documents/Projects/ludmilaphoto/node_modules/.pnpm/nuxt@3.14.1592_sass@1.82.0_typescript@5.7.2/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}